/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import { Palette, routes } from 'config';
import { Link } from 'react-router-dom';
import { useState, useId, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Each, ParagraphWithTooltip, IconButton } from 'components';
import { DeleteIconNew } from 'assets/icons';
import { authActions } from 'store/auth/auth';

export const SelectedPublisherList = ({ getPublisherLink }) => {
  const publisherList = useSelector((state) => state.auth.publisherList);
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  // const publisherItemClick = (pb_number) => {
  //   const manageCampaignUrl = routes.list.find((route) => route.id === 'campaign').url;
  //   const { host, protocol, pathname } = window.location;
  //   let newPathName = pathname.replace('/adminLogin', manageCampaignUrl);
  //   const newDomain = `${protocol}//${pb_number}.${host}${newPathName}`;
  //   //window.open(newDomain, '_blank');
  //   window.open(newDomain, '_self');
  // };

  return (
    <>
      <Box>
        <TableHeader showBottomBorder={publisherList?.length === 0}>
          <HeaderColumn>Account Name</HeaderColumn>
          <HeaderColumn>Email</HeaderColumn>
          <HeaderColumn></HeaderColumn>
        </TableHeader>
        <Each
          of={publisherList}
          render={(item, index) => {
            const { pb_company, pb_email, pb_id, pb_number, selected } = item;
            const isLastElem = publisherList.length === index + 1;

            return (
              <TableRowLink
                to='#'
                //to={getPublisherLink(pb_number)}
                $isLastElem={isLastElem}
                onContextMenu={(e) => {
                  e.preventDefault();
                  const url = getPublisherLink(pb_number);
                  window.location.href = url;
                }}
                onClick={(e) => {
                  e.preventDefault();
                  const url = getPublisherLink(pb_number);
                  window.open(url, '_blank');
                }}
                // onClick={() => publisherItemClick(pb_number)}
              >
                <ParagraphWithTooltip
                  text={`${pb_company}`}
                  style={{
                    textAlign: 'left',
                    color: '#334155',
                    fontSize: '14px',
                    fontWeight: '500',
                  }}
                />
                <ParagraphWithTooltip
                  text={`${pb_email}`}
                  style={{
                    textAlign: 'left',
                    color: '#94A3B8',
                    fontSize: '12px',
                    fontWeight: '400',
                  }}
                />
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'right',
                    paddingRight: '15px',
                    gap: '15px',
                  }}
                >
                  <IconButton.Micro
                    onClick={(e) => {
                      e.stopPropagation();
                      dispatch(authActions.deletePublisherFromList(pb_number));
                    }}
                    icon={DeleteIconNew}
                    type={IconButton.btnTypes.tertiary}
                    isDefaultMuted
                  />
                </div>
              </TableRowLink>
            );
          }}
        />
      </Box>
    </>
  );
};

const Box = styled.div`
  margin-top: 32px;
  color: ${Palette.PrimaryGray._700};
  font-style: normal;
  font-weight: 400;
`;

const TableRowLink = styled.div`
  cursor: pointer;
  text-decoration: none;
  padding-left: 16px;
  display: grid;
  grid-auto-rows: 48px;
  grid-template-columns: 200px 584px 1fr;
  text-align: center;
  align-items: center;
  border: 1px solid ${Palette.PrimaryGray._200};
  border-bottom: ${({ $isLastElem }) => !$isLastElem && 'none'};
  :hover {
    cursor: pointer;
    background: ${Palette.Primary._000};
  }
`;

const TableHeader = styled.div`
  display: grid;
  grid-auto-rows: 40px;
  grid-template-columns: 200px 584px 0.4fr;
  text-align: left;
  align-items: center;
  background: ${Palette.PrimaryGray._000};
  padding-left: 16px;
  border: 1px solid ${Palette.PrimaryGray._200};
  border-bottom: ${({ showBottomBorder }) => !showBottomBorder && 'none'};
`;

const HeaderColumn = styled.p`
  height: 40px;
  line-height: 40px;
`;
